/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetAreaBaseRequest } from '../../models/get-area-base-request';
import { GetAreasResponse } from '../../models/get-areas-response';

export interface PostApiAreaV1$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
      body?: GetAreaBaseRequest
}

export function postApiAreaV1$Json(http: HttpClient, rootUrl: string, params?: PostApiAreaV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetAreasResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiAreaV1$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetAreasResponse>;
    })
  );
}

postApiAreaV1$Json.PATH = '/private/v1/areas';
